import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Entity } from '../../../types'
import type { Plugin } from '../plugin'

import { _buildInfoEntries } from './send-message'

/**
 * Effect that handles sending messages to the agent with file uploads
 */
export const addMessageOnRequest = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    feature.actions.sendMessage.request.observe().pipe(
      rxjs.switchMap(({ data }) => {
        const source = 'addMessageOnRequest (effect)'
        const message: Entity = {
          conversationId: data.conversationId,
          createdAt: new Date(),
          id: data.messageId,
          info: _buildInfoEntries({
            content: data.content,
            fileNames: data.files.map(file => file.name),
          }),
          role: 'user',
          status: 'pending',
        }
        return rxjs.from([
          plugin.collection.plugins.cachePlugin.feature.actions.put
            .from(source)
            .create({ entity: message }),
          plugin.collection.plugins.currentListPlugin.feature.actions.insert
            .from(source)
            .create({ ids: [message.id] }),
          // The cache is emptied when the conversation changes, which a first
          // message causes, so the message is also kept here until a read of
          // its conversation lists it.
          feature.actions.putSent.from(source).create({ message }),
        ])
      }),
    ),
)
